// DTD CableTV after-8 PM rule (2026-09-28) — mirrors backend/src/utils/dtdCutoff.js, which
// is what actually enforces it (paymentService.collectPayment). A DTD CableTV recharge paid at
// or after 8 PM whose new period would start today (or earlier, plan already lapsed) is counted
// from tomorrow, and its GTPL Saathi order is placed after 9:30 AM tomorrow. Early renewals
// (new period starts after today anyway) are untouched. Times are Indian time whatever the
// device's own timezone.
export const DTD_CUTOFF_HOUR = 20;

function istParts(date = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
  }).formatToParts(date).map((p) => [p.type, p.value]));
  return { ymd: `${parts.year}-${parts.month}-${parts.day}`, hour: Number(parts.hour) };
}

export const istToday = () => istParts().ymd;
export const isAfterDtdCutoff = (at = new Date()) => istParts(at).hour >= DTD_CUTOFF_HOUR;

// "29 Sep 2026" for the day after `at`, Indian time.
export function tomorrowLabel(at = new Date()) {
  const [y, m, d] = istParts(at).ymd.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + 1)).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

// True when the rule applies to a DTD CableTV recharge collected at `at` whose new period
// would start on `periodFrom` ('YYYY-MM-DD'): after 8 PM and starting that day or earlier.
export function dtdStartsTomorrowFrom(periodFrom, at = new Date()) {
  return isAfterDtdCutoff(at) && !!periodFrom && periodFrom <= istParts(at).ymd;
}

// Same, for the customer-facing pay screens, which don't pick a start date: a renewal starts
// the day after the current expiry, or today if that has already passed.
export function dtdStartsTomorrowForExpiry(expiryDate) {
  return isAfterDtdCutoff() && (!expiryDate || new Date(expiryDate) <= new Date());
}
